<template>
  <div class="EditOnlineBidding">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">在线竞价</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ ProjectName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="right_content">
      <div class="title1">
        倒计时：<b>{{ day }}</b
        >天<b>{{ hr }}</b> 小时 <b>{{ min }}</b> 分 <b>{{ sec }}</b> 秒
      </div>

      <div class="title2" style="margin-top: 15px">联系信息/发票信息</div>
      <div class="change_inform">
        <el-form :inline="true" :model="supplierQuote" :rules="rules" class="form_table" ref="ruleForm1" :inline-message="true">
          <el-form-item label="联系人" prop="ProjectLeader">
            <el-input v-model="supplierQuote.ProjectLeader" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="Mobile">
            <el-input v-model="supplierQuote.Mobile" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="Address">
            <el-input v-model="supplierQuote.Address" placeholder="请输入联系地址"></el-input>
          </el-form-item>

          <el-form-item label="邮箱" prop="Email">
            <el-input v-model="supplierQuote.Email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="发票类型" prop="InvoiceType" label-width="150px" ref="InvoiceType">
            <el-select v-model="supplierQuote.InvoiceType" placeholder="请选择">
              <el-option v-for="item in supplierQuote.InvoiceTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="税率(%)" prop="RateType">
            <el-select class="rate_type" v-model="supplierQuote.RateType" placeholder="请选择" @change="fnRateTypeChange">
              <el-option v-for="item in supplierQuote.BiddingTaxRateList" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
            <el-input-number
              v-if="isShowRate"
              v-model="supplierQuote.Rate"
              :min="0"
              :max="100"
              placeholder="请输入税率"
              class="input_number"
              style="text-align: left; margin-left: 10px"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="下载合同模板">
            <span class="btn_1" @click="downloadTemplate()">下载合同模板</span>
          </el-form-item>
          <el-form-item></el-form-item>
        </el-form>
      </div>
      <div class="title2" style="display: flex">
        报价清单<span class="title2_span"
          >当前报价合计(元)：{{ totalPrice }} <label style="margin-left: 18px">上一轮报价合计(元)：{{ supplierQuote.LastPrice }}</label></span
        >
      </div>
      <el-table :data="supplierQuote.ProjectList" class="el_table" border :default-expand-all="true">
        <el-table-column prop="Index" label="序号" width="50px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="right" inline class="demo-table-expand" style="width: 80%">
              <el-form-item label="设备名称">
                <span style="float: left">{{ props.row.InstrumentName }}</span>
              </el-form-item>
              <el-form-item label="供货设备名称（与发票保持一致）" prop="SupplierInstrumentName">
                <span style="float: left">
                  <el-input v-model="props.row.SupplierInstrumentName" placeholder="请输入供货设备名称"></el-input>
                </span>
              </el-form-item>
              <!-- <el-form-item></el-form-item> -->
              <el-form-item label="需求型号">
                <span style="float: left">{{ props.row.Specification }}</span>
              </el-form-item>
              <el-form-item label="供货型号" prop="SupplierSpecification">
                <span style="float: left">
                  <el-input
                    v-if="props.row.Specification == '不限'"
                    v-model="props.row.SupplierSpecification"
                    placeholder="请输入供货规格型号"
                  ></el-input>
                  <span v-else>{{ props.row.SupplierSpecification }}</span>
                </span>
              </el-form-item>
              <el-form-item label="单位">
                <span style="float: left">{{ props.row.Unit }}</span>
              </el-form-item>
              <el-form-item label="供货设备数量单位" prop="SupplierUnit">
                <span style="float: left">
                  <el-input v-model="props.row.SupplierUnit" placeholder="请输入供货设备数量单位"></el-input>
                </span>
              </el-form-item>
              <el-form-item label="需求品牌">
                <span style="float: left">{{ props.row.SchemeTrademark }}</span>
              </el-form-item>
              <el-form-item label="供货品牌" prop="Trademark">
                <span style="float: left">
                  <el-input v-if="props.row.SchemeTrademark == '不限'" v-model="props.row.Trademark" placeholder="请输入品牌响应"></el-input>
                  <span v-else>{{ props.row.Trademark }}</span>
                </span>
              </el-form-item>
              <el-form-item label="货期要求（天）">
                <span style="float: left">自合同签订之日起{{ props.row.SchemeDeliveryTime }}个自然日</span>
              </el-form-item>
              <el-form-item label="货期响应" prop="DeliveryTime">
                <span style="float: left">
                  <el-input-number
                    v-model="props.row.DeliveryTime"
                    :min="props.row.SchemeDeliveryTime == 0 ? 0 : 1"
                    :max="Number(props.row.SchemeDeliveryTime)"
                    placeholder="货期响应"
                    class="input_number"
                  ></el-input-number
                  >个自然日
                </span>
              </el-form-item>
              <el-form-item label="安装调试要求（天）">
                <span style="float: left">乙方负责在到货后{{ props.row.SchemeTestCycle }}个自然日内完成货物的安装调试</span>
              </el-form-item>
              <el-form-item label="安装调试响应" prop="TestCycle">
                <span style="float: left">
                  <el-input-number
                    v-model="props.row.TestCycle"
                    :max="Number(props.row.SchemeTestCycle)"
                    :min="props.row.SchemeTestCycle == 0 ? 0 : 1"
                    placeholder="安装调试响应"
                    class="input_number"
                  >
                  </el-input-number
                  >个自然日
                </span>
              </el-form-item>
              <el-form-item label="保修要求（年）">
                <span style="float: left">自甲方内部验收之日起{{ props.row.SchemeWarrantyRequirement }}个自然年</span>
              </el-form-item>
              <el-form-item label="保修期响应" prop="WarrantyRequirement">
                <span style="float: left">
                  <el-input-number
                    v-model="props.row.WarrantyRequirement"
                    :min="Number(props.row.SchemeWarrantyRequirement)"
                    placeholder="保修期响应"
                    class="input_number"
                  >
                  </el-input-number
                  >年
                </span>
              </el-form-item>
              <el-form-item label="含税单价(元)">
                <span style="float: left">
                  <el-input-number v-model="props.row.Price" :min="0" placeholder="请输入单价" class="input_number"> </el-input-number>
                </span>
              </el-form-item>
              <el-form-item label="含税总价(元)" prop="WarrantyRequirement">
                <span style="float: left">
                  {{ parseFloat(parseFloat(props.row.Price) * parseFloat(props.row.Count)).toFixed(2) }}
                </span>
              </el-form-item>
              <el-form-item label="不含税单价(元)">
                <span style="float: left">
                  {{ parseFloat(parseFloat(props.row.Price) / (1 + parseFloat(supplierQuote.Rate) / 100)).toFixed(2) }}
                </span>
              </el-form-item>
              <el-form-item label="不含税总价(元)" prop="WarrantyRequirement">
                <span style="float: left">
                  {{
                    parseFloat((parseFloat(props.row.Price) * parseFloat(props.row.Count)) / (1 + parseFloat(supplierQuote.Rate) / 100)).toFixed(2)
                  }}
                </span>
              </el-form-item>
              <el-form-item label="技术参数要求">
                <el-link
                  @click="fnReadPdf(props.row.fileId2 == '' ? props.row.fileId1 : props.row.fileId2)"
                  :underline="false"
                  style="color: #0361b1; float: left"
                >
                  预览</el-link
                >
              </el-form-item>
              <el-form-item label="技术参数响应">
                <template>
                  <span style="float: left">
                    <el-upload
                      class="upload-demo"
                      :limit="1"
                      :file-list="props.row.FileList"
                      action="11"
                      :auto-upload="true"
                      :data="{ id: props.$index }"
                      :on-preview="handleDownLoad"
                      :http-request="uploadSectionFile"
                      :before-remove="handleBeforeRemove"
                      :on-remove="handleRemove"
                    >
                      <div>
                        <span class="Tip">Tips:</span>
                        <span class="Tip1">技术参数文件请勿出现公司名称等基本信息，仅需上传参数文件内容即可，否则将判定无效竞价！</span>
                      </div>
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </span>
                </template>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="InstrumentName" label="设备名称" width="200"></el-table-column>
        <el-table-column prop="PlanCode" label="计划编号" width="200"></el-table-column>
        <!-- <el-table-column prop="Specification" label="设备型号" width="200"></el-table-column> -->

        <el-table-column prop="Count" label="数量" width="100">
          <template slot-scope="scope">
            {{ scope.row.Count }}
          </template>
        </el-table-column>
        <el-table-column prop="ReceivingCompanyCode" label="收货地址" width="200"></el-table-column>
        <el-table-column prop="SettlementMethodName" label="结算方式" width="200"></el-table-column>
        <el-table-column prop="FixedPrice" label="限价(元)" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.FixedPrice > 0">{{ scope.row.FixedPrice }}</span>
            <span v-else>不限价</span>
          </template>
        </el-table-column>
        <el-table-column prop="PaymentRatio" label="付款比例" align="center" width="600">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.PaymentRatio" :key="index">{{ item }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="TraceabilityRequirement" label="溯源要求" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.TraceabilityRequirement == true ? '需要' : '不需要' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="TraceabilityUnit" label="溯源单位" width="200"></el-table-column>
        <el-table-column prop="OthersRequirement" label="其他要求" width="200"></el-table-column>

        <el-table-column label="上一轮含税总价(元)" prop="LastPrice" width="200"></el-table-column>
      </el-table>

      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" v-loading.fullscreen.lock="fullscreenLoading" @click="fnSave(false)">保存</span>
        <span class="btn_1" v-loading.fullscreen.lock="fullscreenLoading" @click="fnSave(true)">保存并申请</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      OperationId: 0,

      NowTime: 0,
      day: 0,
      hr: 0,
      min: 0,
      sec: 0,
      ProjectName: this.$route.query.ProjectName,
      SchemeId: this.$route.query.SchemeId,
      IsQuote: this.$route.query.IsQuote,
      isShowRate: false,
      fullscreenLoading: false,
      isclick: false,
      supplierQuote: {
        ProjectList: []
      },
      rules: {
        ProjectLeader: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
        Mobile: [{ required: true, message: '请填写联系电话', trigger: 'blur' }],
        Address: [{ required: true, message: '请填写联系地址', trigger: 'blur' }],
        Email: [{ required: true, message: '请填写邮箱', trigger: 'blur' }],
        InvoiceType: [{ required: true, message: '请选择发票类型', trigger: 'blur' }],
        RateType: [{ required: true, message: '请选择税率', trigger: 'blur' }]
      }
    }
  },
  computed: {
    totalPrice: function () {
      var sum = 0
      this.supplierQuote.ProjectList.forEach((item) => {
        sum = sum + parseFloat(item.Price) * parseFloat(item.Count)
      })
      return sum.toFixed(2)
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    fnRateTypeChange(val) {
      let selectRateType = this.supplierQuote.BiddingTaxRateList.find(function (item) {
        return item.value == val
      })
      this.supplierQuote.Rate = selectRateType.remark
      console.log('select:', this.supplierQuote.Rate)
      if (val == '4') {
        this.isShowRate = true
      } else {
        this.isShowRate = false
      }
    },
    getData() {
      let config = {
        params: {
          SchemeId: this.SchemeId
        }
      }

      this.getRequest('Purchase/GetCurrentQuote', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.supplierQuote = res.data.supplierQuote
            this.isShowRate = this.supplierQuote.RateType == '4'
            this.supplierQuote.ProjectList.forEach((item) => {
              if (item.SchemeTrademark != '不限') {
                item.Trademark = item.SchemeTrademark
              }
            })
            this.NowTime = new Date(this.supplierQuote.NowTime).getTime()
            this.countdown(this.supplierQuote.EvaluationEndTime)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    countdown: function (EndTime) {
      let interval = setInterval(() => {
        //定义this指向
        const that = this
        that.NowTime = that.NowTime + 1000
        //设置结束时间
        const end = new Date(EndTime).getTime()
        //设置开始时间
        const now = that.NowTime

        // 做判断当倒计时结束时都为0
        if (now >= end) {
          that.day = 0
          that.hr = 0
          that.min = 0
          that.sec = 0
          return
        }
        // 用结束时间减去当前时间获得倒计时时间戳
        const msec = end - now
        let day = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
        let hr = parseInt((msec / 1000 / 60 / 60) % 24) //算出小时数
        let min = parseInt((msec / 1000 / 60) % 60) //算出分钟数
        let sec = parseInt((msec / 1000) % 60) //算出秒数
        //给数据赋值
        that.day = day
        that.hr = hr > 9 ? hr : '0' + hr
        that.min = min > 9 ? min : '0' + min
        that.sec = sec > 9 ? sec : '0' + sec
      }, 1000)
    },
    handleDownLoad(file) {
      let token = window.localStorage.getItem('loginToken')
      var url = 'Common/DownLoadFile?fileId=' + file.id + '&token=' + token + '&fileName=' + file.name

      this.downloadfile(this.baseURL + url)
    },
    handleBeforeRemove(file) {
      let isDelete = true
      if (file && file.status === 'success') {
        isDelete = this.$confirm(`确定删除 ${file.name}？`)
      }
      return isDelete
    },
    handleRemove(file) {
      if (this.IsQuote) {
      } else {
        if (file && file.status === 'success') {
          this.supplierQuote.ProjectList.forEach((item) => {
            if (item.id == file.id) {
              item.FileList = []
            }
          })
        }
      }
    },
    uploadSectionFile(params) {
      const file = params.file
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension =
        testmsg.toLowerCase() === 'pdf' ||
        testmsg.toLowerCase() === 'doc' ||
        testmsg.toLowerCase() === 'docx' ||
        testmsg.toLowerCase() === 'xls' ||
        testmsg.toLowerCase() === 'xlsx'
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension) {
        this.$message({
          message: '只能上传word、excel、pdf文件!',
          type: 'warning'
        })
        this.supplierQuote.ProjectList[params.data.id].FileList = []
        return
      }
      if (file.size > 200 * 1024 * 1024) {
        this.$message.error('请上传小于200M的文件！')
        this.supplierQuote.ProjectList[params.data.id].FileList = []
        return
      }
      var data = new window.FormData()
      data.append('file', file)
      data.append('loginToken', window.localStorage.getItem('loginToken'))
      this.uploadFileRequest('/Common/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          var fileList = [
            {
              id: res.data.FileList[0].fileId,
              name: res.data.FileList[0].fileName,
              BusinessAttachmentId: res.data.FileList[0].fileName
            }
          ]
          this.supplierQuote.ProjectList[params.data.id].FileList = fileList
          console.log(this.supplierQuote)
        }
      })
    },
    fnReadPdf(fileId) {
      let routerData = this.$router.resolve({
        path: 'ReadPDF',
        query: {
          fileId: fileId
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnSave(toCa) {
      let issubmit = true

      if (this.isclick == false) {
        this.isclick = true
        this.supplierQuote.Price = this.totalPrice
        this.supplierQuote.IsSubmit = toCa
        this.supplierQuote.ProjectList.forEach((item) => {
          if ((item.SupplierInstrumentName == '' || item.SupplierInstrumentName == null) && issubmit) {
            this.$message.error('请填写(' + item.InstrumentName + ')供应商产品名称')
            issubmit = false
            this.isclick = false
            return false
          }
          if ((item.SupplierSpecification == '' || item.SupplierSpecification == null) && issubmit) {
            this.$message.error('请填写(' + item.InstrumentName + ')供货型号')
            issubmit = false
            this.isclick = false
            return false
          }
          if (typeof item.Price == 'undefined' && issubmit) {
            this.$message.error('请填写(' + item.InstrumentName + ')单价')
            issubmit = false
            this.isclick = false
            return false
          }
          if (Number(item.Price) <= 0 && issubmit) {
            this.$message.error('设备(' + item.InstrumentName + ')报价0元，请重新报价')
            issubmit = false
            this.isclick = false
            return false
          }
          if (item.Trademark == '' && item.SchemeTrademark == '不限' && issubmit) {
            this.$message.error('请填写(' + item.InstrumentName + ')供货品牌')
            issubmit = false
            this.isclick = false
            return false
          }
          if (typeof item.DeliveryTime == 'undefined' && issubmit) {
            this.$message.error('请填写(' + item.InstrumentName + ')货期响应')
            issubmit = false
            this.isclick = false
            return false
          }
          if (typeof item.WarrantyRequirement == 'undefined' && issubmit) {
            this.$message.error('请填写(' + item.InstrumentName + ')保修响应')
            issubmit = false
            this.isclick = false
            return false
          }
          if (typeof item.TestCycle == 'undefined' && issubmit) {
            this.$message.error('请填写(' + item.InstrumentName + ')安装调试响应')
            issubmit = false
            this.isclick = false
            return false
          }
          if (item.FileList.length == 0 && issubmit) {
            this.$message.error('请上传(' + item.InstrumentName + ')供货技术参数')
            issubmit = false
            this.isclick = false
            return false
          }
          if (item.FixedPrice > 0) {
            if (parseFloat(item.Price * item.Count) > item.FixedPrice) {
              this.$message.error(item.InstrumentName + '的报价大于限价，请重新填写')
              issubmit = false
              this.isclick = false
              return false
            }
          }
        })
        if (!this.supplierQuote.IsFirstQoute) {
          if (Number(this.supplierQuote.Price) >= Number(this.supplierQuote.LastPrice)) {
            this.$message.error('当前报价合计必须小于上一轮报价合计')
            issubmit = false
            this.isclick = false
            return false
          }
        }
        if (issubmit == true) {
          this.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              this.fullscreenLoading = true
              this.postRequest('Purchase/SaveOnlineBiddingData', {
                supplierQuoteJson: JSON.stringify(this.supplierQuote)
              })
                .then((res) => {
                  if (res.data.errcode == 0) {
                    this.OperationId = res.data.OperationId
                    this.fullscreenLoading = false
                    this.isclick = false
                    this.$message.success('保存成功！')
                    if (toCa == true) {
                      this.goCASeal(this.OperationId, res.data.QuotationFileId)
                    }
                  } else {
                    this.isclick = false
                    this.$message.error(res.data.errmsg)
                  }
                })
                .catch(function (error) {
                  console.log(error)
                })
            }
          })
        }
      }
    },
    goCASeal(OperationId, QuotationFileId) {
      let routerData = this.$router.resolve({
        name: 'CASeal',
        query: {
          OperationId: OperationId,
          QuotationFileId: QuotationFileId,
          ProjectName: this.ProjectName,
          EvaluationEndTime: this.supplierQuote.EvaluationEndTime,
          IsQuote: this.IsQuote,
          SchemeId: this.SchemeId
        }
      })
      window.open(routerData.href, '_blank')
      setTimeout(() => {
        window.close()
      }, 2000)
    },
    downloadTemplate() {
      var templatefilePath = '~/App_Data/Template/设备采购合同模板.docx'
      var fileName = '设备采购合同模板'
      var url = 'SupplierLogin/DownloadTemplate?TemplatefilePath=' + templatefilePath + '&FileName=' + fileName
      this.downloadfile(this.baseURL + url)
    }
  }
}
</script>
<style scoped lang="scss">
.demo-table-expand {
  font-size: 0;
  background-color: #ecf5ff;
}

.demo-table-expand ::v-deep .el-form-item__label {
  width: 30%;
  font-weight: bold;
}

.demo-table-expand ::v-deep .el-form-item__content {
  width: 70%;
}

.demo-table-expand ::v-deep .el-form-item {
  margin-right: 0;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 50%;
}

.currentMenu {
  margin: 16px 5px;
}

.right_content {
  margin: 0 10px;
  height: 93%;
  background: #fff;
}

.title1 {
  padding: 10px 0;
  background-color: #f9f9d2;
  text-align: center;
  color: #ff6600;
  font-size: 16px;
}

.list_wrap1 {
  display: flex;
  flex-wrap: wrap;
  padding: 0 8px;

  .list {
    width: 33%;
    display: flex;
    padding-bottom: 8px;
  }

  .text1 {
    color: #0660a2;
    font-weight: bold;
    white-space: nowrap;
  }
}

.title2 {
  font-size: 18px;
  border-bottom: 1px solid #95c7f0;
  padding-bottom: 7px;
  margin: 7px;
}

.list_wrap2 {
  display: flex;
  margin: 0 7px;

  .list {
    padding: 10px 0;
    border-radius: 6px;
    width: 49%;
    display: flex;
    margin-right: 1%;
    background: #f2f2f2;
    align-items: flex-start;
    justify-content: center;

    .img1 {
      padding-right: 20px;
      border-right: 1px solid #ccc;
      margin-right: 10px;
    }

    .right_text {
      padding-top: 4px;
      flex: 0.4;
      display: flex;

      .text_num {
        color: #f00;
        margin-top: 8px;
        font-size: 26px;
      }

      .text_warning {
        margin-top: 6px;
        white-space: nowrap;
      }

      .text1 {
        margin-right: 26px;
      }

      .text2 {
        margin-top: -6px;
      }

      .btn {
        background: #ff6600;
        color: #fff;
        text-align: center;
        padding: 12px 0;
        border-radius: 6px;
        width: 100px;
      }
    }
  }
}

.el-icon-warning {
  margin-right: 3px;
}

.el-icon-warning:before {
  color: #ff9900;
  font-size: 15px;
}

//重写el_tabs样式
.el_tabs {
  margin: 7px 7px 0;
}

.el_tabs ::v-deep .el-tabs__header {
  float: none;
  margin-right: 0;
  margin-bottom: 0;

  .el-tabs__nav-wrap::after {
    background-color: #95c7f0;
  }

  .el-tabs__item {
    padding: 0 40px;
    color: #054c81;
  }

  .el-tabs__item.is-active {
    color: #fff;
    background: #2db7f5;
  }

  .el-tabs__active-bar {
    display: none;
  }
}

//重写el-table样式
.el_table {
  width: 100%;
  margin: 0 auto;
  border: none;
}

.el_table ::v-deep .el-table__header {
  th {
    background: #f2f2f2;
    text-align: center;
    border-bottom: 2px solid #e4e4e4;
    color: #333;
  }
}

.el_table ::v-deep .el-table__body-wrapper {
  tr {
    background-color: #e6f6fb;
  }

  td {
    text-align: center;
    border-bottom: 1px solid #e4e4e4;
    border-right: none;
    background-color: #fff;
  }
}

.main_content {
  display: flex;
}

.left_Wrap {
  background: #abc9e1;
  width: 300px;
}

.right_Wrap {
  flex: 1;
}

.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}

.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 10px;

  .btn_1 {
    background: #f60;
    border: 1px solid #f60;
    color: #fff;
    border-radius: 8px;
  }

  .btn_1:nth-of-type(1) {
    margin-right: 30px;
  }
}

.title2_span {
  margin-left: auto;
  color: #0660a2;
  font-weight: bold;
  font-size: 13px;
}

.input_number {
  ::v-deep.el-input-number__increase {
    visibility: hidden;
  }

  ::v-deep.el-input-number__decrease {
    visibility: hidden;
  }

  ::v-deep .el-input__inner {
    text-align: left;
  }
}

::v-deep .change_inform .el-form .el-form-item .rate_type .el-input {
  width: 100px !important;
}
.Tip {
  font-weight: bold;
  font-style: italic;
  color: #ff5c00;
  margin-right: 5px;
}
.Tip1 {
  // font-weight: bold;
  // font-style: italic;
  color: #ff0000;
  margin-right: 5px;
}
</style>